import { Link } from "react-router-dom";

export const FAQS = {
  patient: [
    {
      title: "Menambahkan pasien",
      solution: (
        <ul className="list-disc list-inside">
          <li className="">
            Untuk menambahkan pasien, silakan pergi ke halaman
            <Link to="/patient">
              <span className="text-warning mx-1">pasien</span>
            </Link>
            , kemudian klik tambah pasien
          </li>
          <li className="mt-1">
            Isi form yang memuat nama, jenis kelamin, tanggal lahir, berat
            badan, dan tinggi badan. Semua nilai harus ada kecuali tanggal
            lahir.
          </li>
          <li className="mt-1">Klik simpan untuk menambahkan pasien</li>
        </ul>
      ),
    },
    {
      title: "Mengubah Data Pasien",
      solution: (
        <ul className="list-disc list-inside">
          <li className="">
            Untuk menambahkan pasien, silakan pergi ke halaman
            <Link to="/patient">
              <span className="text-warning mx-1">pasien</span>
            </Link>
            , kemudian pilih salah satu pasien yang akan diubah datanya
          </li>
          <li className="mt-1">
            Pada halaman detail pasien terdapat tombol untuk mengubah data, klik
            tombol tersebut, kemudian akan muncul form untuk melakukan perbaikan
            data
          </li>
          <li className="mt-1">
            Data yang bisa diubah antara lain: tanggal lahir, berat dan tinggi
            badan
          </li>
          <li className="mt-1">
            Perbaiki data pasien, kemudian tekan tombol simpan untuk melakukan
            perbaikan data.
          </li>
        </ul>
      ),
    },
    {
      title: "Melihat Rekam Medis Pasien",
      solution: (
        <ul className="list-disc list-inside">
          <li className="">
            Untuk melihat rekam medis pasien, silakan pergi ke halaman
            <Link to="/patient">
              <span className="text-warning mx-1">pasien</span>
            </Link>
            , kemudian pilih salah satu pasien.
          </li>
          <li className="mt-1">
            Disana akan muncul daftar rekam medis pasien, klik lihat untuk
            melihat rincian rekam medis.
          </li>
          <li className="mt-1">
            Jika ingin melihat rekam medis secara keseluruhan, pilih tombol
            statistik pada halaman detail pasien.
          </li>
        </ul>
      ),
    },
  ],
  record: [],
  device: [
    {
      title: "Menambahkan perangkat",
      solution: (
        <ul className="list-disc list-inside">
          <li className="">
            Silakan menuju kehalaman
            <Link to="/device">
              <span className="text-warning mx-1">perangkat</span>
            </Link>
            , untuk menambahkan perangkat respinos.
          </li>
          <li className="mt-1">
            Klik tombol tambah perangkat. Kemudian isi nama perangkat dan token
            sesuai dengan informasi yang tertera pada box perangkat.
          </li>
          <li className="mt-1">
            Klik "tambahkan" untuk mendaftarkan perangkat pada aplikasi ini.
          </li>
        </ul>
      ),
    },
    {
      title: "Perangkat dalam kondisi inactive",
      solution: (
        <ul className="list-disc list-inside">
          <li className="mt-1">
            Jika status perangkat dalam keadaan "inactive" maka perangkat tidak
            terhubung ke jaringan internet. Periksa perangkat apakah sudah
            menyala dan terkoneksi ke dalam jaringan internet.
          </li>
          <li className="mt-1">
            Jika sudah menyala tapi tidak terhubung ke jaringan, maka anda perlu
            melakukan pengaturan wifi. klik "set wifi" untuk melakukan
            pengaturan jaringan pada perangkat respinos.
          </li>
          <li className="mt-1">
            Pastikan terdapat wifi yang tersedia di tempat respinos berada.
            Ikutilah petunjuk yang terdapat pada halaman konfigurasi wifi.
          </li>
        </ul>
      ),
    },
    {
      title: "Menggunakan Perangkat",
      solution: (
        <ul className="list-disc list-inside">
          <li className="mt-1">
            Pilih perangkat yang hendak anda gunakan. Pastikan statusnya dalam
            kondisi aktif.
          </li>
          <li className="mt-1">
            Perhatikan nama pengguna yang tertera pada web. Jika itu bukan anda,
            silakan reset pengguna dengan menekan tombol reset pada respinos.
          </li>
          <li className="mt-1">
            Pilih lihat untuk masuk ke halaman detail perangkat
          </li>
          <li className="mt-1">
            Klik tombol gunakan perangkat untuk memilih pasien. Jika anda belum
            mendaftarkan pasien, silakan tambahkan pasien terlebih dahulu di
            halaman pasien
          </li>
          <li className="mt-1">
            Tekan tombol start/stop untuk mengendalikan perangkat. Hasil
            pengukuran anda bisa lihat di halaman rekam medis.
          </li>
        </ul>
      ),
    },
  ],
  profile: [
    {
      title: "Mengubah profile pengguna",
      solution: (
        <ul className="list-disc list-inside">
          <li className="">
            Pada aplikasi ini anda bisa mengubah profil berupa: nama, tempat
            praktik, nomor STR, deskripsi, atau avatar.
          </li>
          <li className="mt-1">
            Pada halaman profil, klik ubah profil untuk menampilkan form untuk
            menguabah profil.
          </li>
          <li className="mt-1">
            Isi perubahan profil, kemudian tekan tombol simpan untuk memperbaiki
            data.
          </li>
        </ul>
      ),
    },
    {
      title: "Mengubah password pengguna",
      solution: (
        <ul className="list-disc list-inside">
          <li className="">
            Untuk keamanan, anda bisa mengubah password aplikasi ini.
          </li>
          <li className="mt-1">
            Di halaman profil, pilih ubah password, kemudian isi password lama,
            password baru dan konfirmasi password baru.
          </li>
          <li className="mt-1">
            Untuk menyimpan password baru, silakan tekan tombol simpan.
          </li>
        </ul>
      ),
    },
    {
      title: "Lupa password",
      solution: (
        <ul className="list-disc list-inside">
          <li className="">
            Anda bisa melakukan reset password ketika anda lupa password untuk
            masuk ke aplikasi ini.
          </li>
          <li className="mt-1">
            Pada halaman login, pilih lupa password, kemudian isi email yang
            telah anda daftarkan sesuai dengan akun anda.
          </li>
          <li className="mt-1">
            Sistem akan mengirimkan link melalui email untuk melakukan perubahan
            password. Gunakan link tersebut untuk mengubah password anda.
          </li>
        </ul>
      ),
    },
  ],
};
